var React = require('react');

function Microwave (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384,352H64V128H384Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M464,64H48A48,48,0,0,0,0,112V368a48,48,0,0,0,48,48l24,32h48l24-32H368l24,32h48l24-32a48,48,0,0,0,48-48V112A48,48,0,0,0,464,64ZM384,352H64V128H384Zm64-72a24,24,0,1,1,24-24A24,24,0,0,1,448,280Zm0-96a24,24,0,1,1,24-24A24,24,0,0,1,448,184Z","className":"fa-primary","key":2})]);
}

Microwave.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Microwave;

Microwave.default = Microwave;
